export const paymentOptionUpdateAction = (data) => {
  return {
    type: "PAYMENT_TYPE_UPDATE",
    payload: data,
  };
};
